import React, { useState, useEffect } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../lib/init-firebase';
import {
  Col,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardSubtitle,
  CardText,
  Button,
  CardGroup,
  Input,
} from 'reactstrap';
import { Link } from 'react-router-dom';

export default function Posts(props) {
  const [posts, setPosts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchTermChange = (event) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  useEffect(() => {
    getPosts();
  }, []);

  function getPosts() {
    const postsRef = collection(db, 'posts');
    getDocs(postsRef)
      .then((response) => {
        const allPosts = response.docs.map((doc) => ({
          data: doc.data(),
          id: doc.id,
        }));
        setPosts(allPosts);
      })
      .catch((error) => console.log(error.message));
  }

  const renderPosts = posts
    .reverse()
    .filter((post) =>
      post.data.postTitle.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .map((post) => {
      return (
        <Col sm="12" md="6" lg="4">
          <Card key={post.data.id} className="margin-sm box-shadow">
            <CardImg
              src={post.data.coverImg}
              alt={'Imagen post: ' + post.data.postTitle}
              top
              width="100%"
            />
            <CardBody>
              <CardTitle tag="h5">{post.data.postTitle}</CardTitle>
              <CardSubtitle tag="h6" className="mb-2 text-muted">
                {post.data.postSubtitle}
              </CardSubtitle>
              <CardText>
                <div
                  dangerouslySetInnerHTML={{
                    __html: post.data.content.substring(0, 50) + '...',
                  }}
                />
              </CardText>
              <Link
                to={`/posts/${post.id}`}
                state={{
                  coverImg: post.data.coverImg,
                  postTitle: post.data.postTitle,
                  createdDate: post.data.createdDate,
                  postSubtitle: post.data.postSubtitle,
                  content: post.data.content,
                }}
              >
                <Button className="bg-pink border-pink">Ver post</Button>
              </Link>
            </CardBody>
          </Card>
        </Col>
      );
    });

  return (
    <div className="col-full">
      <h1>Posts</h1>
      <br />
      <Input
        type="text"
        placeholder="Ingresá algún texto para buscar..."
        onChange={handleSearchTermChange}
        value={searchTerm}
        name={searchTerm}
      />
      <br />
      <CardGroup>{renderPosts}</CardGroup>
    </div>
  );
}
